module.exports = __webpack_public_path__ + "static/media/9_placeholder_it.3bd0f34f.png";